import { logoPrincipal } from '../assets';
import { useState } from 'react';
import useFirestoreCollection from '../hooks/useFirestoreCollection';

const DEFAULT_SERVICES = [
  'Construcción de marca.',
  'Páginas web.',
  'Marketing digital.',
  'Producción de video y fotografía profesional.',
  'Inteligencia artificial para negocios.',
//  proximamntente ejemplo de servicios copiamos el de arriba para poder duplicarlo
];

export default function Contact() {
  const { data: services } = useFirestoreCollection('services', { orderBy: { field: 'order', direction: 'asc' } });
  const serviceOptions = services.length ? services.map((service) => service.title) : DEFAULT_SERVICES;

  const [form, setForm] = useState({
    nombre: '',
    marca: '',
    email: '',
    whatsapp: '',
    servicio: [], // ✅ ahora es array (checkboxes)
    presupuesto: '',
    descripcion: '',
  });

  const [status, setStatus] = useState({ type: 'idle', message: '' });

  const ENDPOINT_URL =
    'https://script.google.com/macros/s/AKfycbwYuxhj-EgK5rWHxnYH1H9r0rX9ATFUxyhfk6AiFOQdwkwK2Bm3iLWomZKigT3ThwYs/exec';

  const onChange = (e) => {
    const { id, value } = e.target;
    setForm((f) => ({ ...f, [id]: value }));
  };

  const toggleService = (service) => {
    setForm((f) => {
      const has = f.servicio.includes(service);
      return {
        ...f,
        servicio: has ? f.servicio.filter((s) => s !== service) : [...f.servicio, service],
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'loading', message: 'Enviando...' });

    // ✅ validación mínima: al menos 1 servicio
    if (!form.servicio || form.servicio.length === 0) {
      setStatus({ type: 'error', message: 'Selecciona al menos un servicio.' });
      return;
    }

    try {
      const res = await fetch(ENDPOINT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          ...form,
          // ✅ Apps Script guarda servicio como texto legible
          servicio: form.servicio.join(', '),
          page: typeof window !== 'undefined' ? window.location.href : '',
        }),
      });

      const text = await res.text();
      let data = null;
      try {
        data = JSON.parse(text);
      } catch {
        data = null;
      }

      if (!res.ok) {
        setStatus({
          type: 'error',
          message: `Error HTTP ${res.status}. Respuesta: ${text?.slice(0, 180) || '(vacía)'}`,
        });
        return;
      }

      if (!data || data.ok !== true) {
        setStatus({
          type: 'error',
          message: `Respuesta inválida del servidor. Respuesta: ${text?.slice(0, 180) || '(vacía)'}`,
        });
        return;
      }

      if (data.waLink && typeof window !== 'undefined') {
        window.open(data.waLink, '_blank', 'noopener,noreferrer');
      }

      setStatus({ type: 'success', message: 'Enviado correctamente.' });

      setForm({
        nombre: '',
        marca: '',
        email: '',
        whatsapp: '',
        servicio: [],
        presupuesto: '',
        descripcion: '',
      });
    } catch {
      setStatus({
        type: 'error',
        message: 'Error enviando. Revisa el Deploy del Apps Script (Anyone).',
      });
    }
  };

  return (
    <section
      className="py-24 relative overflow-hidden bg-[#EEF2F7] text-slate-900 dark:bg-[#0A0F1A] dark:text-white"
      id="contact"
    >
      <div className="absolute inset-0 z-0 opacity-25 dark:opacity-30">
        <div className="data-particle" style={{ top: '20%', left: '10%', animation: 'float 5s infinite' }} />
        <div className="data-particle" style={{ top: '60%', left: '80%', animation: 'float 7s infinite' }} />
        <div className="data-particle" style={{ top: '30%', left: '40%', animation: 'float 4s infinite' }} />
        <div className="data-particle" style={{ top: '80%', left: '20%', animation: 'float 6s infinite' }} />
      </div>

      <img
        src={logoPrincipal}
        alt=""
        className="absolute inset-0 w-full h-full object-contain opacity-[0.06] dark:opacity-[0.10] pointer-events-none z-0"
        style={{ transform: 'scale(1.25)', filter: 'grayscale(1) contrast(1.05)' }}
      />
      <div className="absolute inset-0 bg-white/10 dark:bg-black/20 pointer-events-none z-0" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row rounded-[3rem] overflow-hidden border border-slate-900/10 dark:border-white/10 shadow-2xl shadow-blue-900/10 dark:shadow-blue-900/20 frosted-pane">
          {/* Left */}
          <div className="lg:w-2/5 p-12 md:p-16 flex flex-col justify-between bg-gradient-to-br from-white/70 to-[#EEF2F7]/70 dark:from-[#1C3152]/80 dark:to-[#0A0F1A]/80 border-b lg:border-b-0 lg:border-r border-slate-900/10 dark:border-white/10">
            <div>
              <h2 className="text-3xl md:text-4xl font-display font-black tracking-tighter mb-8 neon-text-glow italic uppercase text-slate-900 dark:text-white relative z-50">
                Empecemos a trabajar en tu marca.<br /><br /> Déjanos tu información y revisaremos tu negocio para proponerte la mejor forma de hacerlo crecer.
              </h2>
              <p className="text-slate-600 dark:text-slate-400 text-lg font-light mb-12 max-w-xs">
                Completa el formulario y nuestro equipo evaluará tu marca para diseñar una propuesta estratégica personalizada.
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="lg:w-3/5 p-12 md:p-16 bg-white/55 dark:bg-[#1C3152]/40 backdrop-blur-3xl">
            <form className="space-y-8 w-[80%] mx-auto" onSubmit={onSubmit}>
              <input
                type="hidden"
                name="referrer"
                value={typeof window !== 'undefined' ? window.location.href : ''}
                readOnly
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-2">
                  <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="nombre">
                    Nombre
                  </label>
                  <input
                    className="w-full contact-input rounded-2xl py-4 px-6 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-0"
                    id="nombre"
                    placeholder="Tu nombre"
                    type="text" 
                    value={form.nombre}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="marca">
                    Nombre de tu marca
                  </label>
                  <input
                    className="w-full contact-input rounded-2xl py-4 px-6 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-0"
                    id="marca"
                    placeholder="Nombre de tu marca"
                    type="text"
                    value={form.marca}
                    onChange={onChange}
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="w-full contact-input rounded-2xl py-4 px-6 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-0"
                    id="email"
                    placeholder="hola@empresa.com"
                    type="email"
                    value={form.email}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="whatsapp">
                    WhatsApp
                  </label>
                  <input
                    className="w-full contact-input rounded-2xl py-4 px-6 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-0"
                    id="whatsapp"
                    placeholder="+593 999 999 999"
                    type="tel"
                    inputMode="tel"
                    value={form.whatsapp}
                    onChange={onChange}
                  />
                </div>
              </div>

              {/* ✅ Servicio requerido con CHECKBOXES (mejor UX) */}
              <div className="space-y-4">
                <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1">
                  Servicio requerido (elige uno o varios)
                </label>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {serviceOptions.map((service) => {
                    const checked = form.servicio.includes(service);

                    return (
                      <label
                        key={service}
                        className={[
                          'flex items-center gap-3 rounded-2xl px-4 py-4 border transition-all cursor-pointer select-none',
                          checked
                            ? 'border-primary bg-primary/10'
                            : 'border-slate-900/10 dark:border-white/10 bg-white/40 dark:bg-white/5 hover:bg-white/60 dark:hover:bg-white/10',
                        ].join(' ')}
                      >
                        <input
                          type="checkbox"
                          className="h-5 w-5 accent-primary"
                          checked={checked}
                          onChange={() => toggleService(service)}
                        />
                        <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">{service}</span>
                      </label>
                    );
                  })}
                </div>

                {/* input oculto para que el "required" funcione en HTML nativo */}
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  className="pointer-events-none absolute opacity-0"
                  value={form.servicio.join(',')}
                  onChange={() => {}}
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="presupuesto">
                  Presupuesto estimado
                </label>
                <div className="relative">
                  <select
                    className="w-full contact-input rounded-2xl py-4 px-6 text-slate-700 dark:text-slate-300 appearance-none focus:ring-0 pr-12"
                    id="presupuesto"
                    value={form.presupuesto}
                    onChange={onChange}
                  >
                    <option disabled value="">
                      Seleccionar rango
                    </option>
                    <option>Menos de $500</option>
                    <option>$500 – $1,500</option>
                    <option>$1,500 – $3,000</option>
                    <option>$3,000 – $7,000</option>
                    <option>$7,000 – $15,000</option>
                    <option>Más de $15,000</option>
                  </select>
                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <span className="material-symbols-outlined text-2xl text-[#3662E2] dark:text-slate-400">
                      keyboard_arrow_down
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black tracking-[0.3em] uppercase text-primary ml-1" htmlFor="descripcion">
                  Descripción del proyecto
                </label>
                <textarea
                  className="w-full contact-input rounded-3xl py-4 px-6 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 min-h-[180px] focus:ring-0"
                  id="descripcion"
                  placeholder="Cuéntanos qué necesitas, objetivos, tiempos y cualquier detalle importante..."
                  value={form.descripcion}
                  onChange={onChange}
                  required
                />
              </div>

              {status.type !== 'idle' ? (
                <div
                  className={[
                    'text-sm font-semibold',
                    status.type === 'success' ? 'text-emerald-600 dark:text-emerald-400' : '',
                    status.type === 'error' ? 'text-red-600 dark:text-red-400' : '',
                    status.type === 'loading' ? 'text-slate-500 dark:text-slate-300' : '',
                  ].join(' ')}
                >
                  {status.message}
                </div>
              ) : null}

              <button
                className="w-full bg-primary hover:bg-[#2D54C7] text-white py-6 rounded-2xl font-black text-lg tracking-[0.2em] flex items-center justify-center gap-4 transition-all hover:shadow-[0_0_30px_rgba(54,98,226,0.8)] group uppercase disabled:opacity-60 disabled:cursor-not-allowed"
                type="submit"
                disabled={status.type === 'loading'}
              >
                Enviar
                <span className="material-symbols-outlined transform group-hover:translate-x-2 group-hover:-translate-y-1 transition-transform">
                  send
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}